module.exports = __webpack_public_path__ + "static/img/index-m-01.d9c1126.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index-m-01.png
// module id = 8i7o
// module chunks = 0